
import React, { useState, useEffect } from "react";
import Navigation from "../Components/Navigation";

const Settings = () => {
  const [theme, setTheme] = useState(() => localStorage.getItem("travelxoxo-theme") || "light");
  const [activeScreen, setActiveScreen] = useState("analytics");

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("travelxoxo-theme", theme);
  }, [theme]);

  const toggleTheme = () => setTheme((t) => (t === "light" ? "dark" : "light"));

  return (
    <div className="flex bg-gray-50 dark:bg-gray-900 min-h-screen transition-colors duration-300">
      {/* Side Navigation */}
      <Navigation
        activeScreen={activeScreen}
        setActiveScreen={setActiveScreen}
        theme={theme}
        toggleTheme={toggleTheme}   
      />

      {/* Main Content */}
      <main className="flex-1 ml-20 md:ml-64 p-6 md:p-10">
        <h1 className="text-3xl font-bold mb-6 text-gray-900 dark:text-white">
          settings
        </h1>
        {/* You can add more page content here */}
      </main>
    </div>
  );
};

export default Settings;